import moment from 'moment';
import { getConfig } from '../../../util/configUtil';

export const isMTSVersion = (value, startDate) => {
    // Configs
    const mtsEnabled = getConfig('modules.acuity.mtsEnabled', false);
    const useECDSAcuitySince = getConfig('modules.acuity.useECDSAcuitySince', moment().format('YYYY-MM-DD'));
    const useMTSSince = getConfig('modules.acuity.useMTSSince', null);

    // Check if the form is filled out correctly
    if (value?.firstDiscriminator) {
        // Show MTS if ecdsVersion field is missing (ECDS uses ecdsVersion, MTS doesn't)
        return !value?.firstDiscriminator.hasOwnProperty('ecdsVersion');
    } else {
        // New form: determine acuity version based on admit/start date
        const start = moment(startDate);
        const sinceDateCheck = mtsEnabled ? useMTSSince : useECDSAcuitySince;
        const since = sinceDateCheck ? moment(sinceDateCheck) : null;
        if (!since) {
            // Unable to determine which acuity version to use - configuration is missing
            alert('Missing acuity version configuration');
            console.error('Missing acuity version configuration (useECDSAcuitySince or useMTSSince)');
            return false;
        } else {
            return mtsEnabled ? start.isSameOrAfter(since) : start.isBefore(since);
        }
    }
};
